import { Time2 } from "@common/formx";
import { Box, Button, Grid, IconButton, makeStyles, Typography } from "@material-ui/core";
import React from "react";
import { fastOptions } from "./utils";
import { Delete } from "@material-ui/icons";

interface PeriodRowProps {
  index: number;
  name: string;
  isRemovable: boolean;
  onChange: (from: string, to: string) => void;
  onRemove: () => void;
}

export const PeriodRow: React.FC<PeriodRowProps> = ({
  index,
  name,
  onChange,
  onRemove,
  isRemovable
}) => {
  const classes = useStyles();

  return (
    <Grid container spacing={1}>
      {isRemovable && (
        <Grid item xs={12}>
          <Box display={"flex"} alignItems="center" justifyContent="space-between">
            <Typography className={classes.title}>Pass {index + 1}</Typography>
            <IconButton onClick={onRemove} size="small" className={classes.removeBtn}>
              <Delete fontSize="small" />
            </IconButton>
          </Box>
        </Grid>
      )}
      <Grid item xs={6}>
        <Time2
          name={`${name}.from`}
          DatePickerProps={{
            timeIntervals: 15,
            fullWidth: true
          }}
        />
      </Grid>
      <Grid item xs={6}>
        <Time2
          name={`${name}.to`}
          DatePickerProps={{
            timeIntervals: 15,
            fullWidth: true
          }}
        />
      </Grid>

      {fastOptions.length > 0 && (
        <Grid item xs={12} style={{ paddingTop: 16 }}>
          {fastOptions.map((opt, i) => (
            <Button
              key={i}
              onClick={() => onChange(opt.from, opt.to)}
              variant="outlined"
              style={{ marginRight: 8 }}
            >
              {opt.from}-{opt.to}
            </Button>
          ))}
        </Grid>
      )}
    </Grid>
  );
};

const useStyles = makeStyles((theme) => ({
  title: {
    fontWeight: "bold"
  },
  removeBtn: {
    marginRight: "6px"
  }
}));
